<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">언어</td>
                <td>
                    <div>
                        <el-select v-model="country" placeholder="언어를 선택해주세요." @change="parentChange('country', country)" :disabled="id!=null">
                            <el-option
                                    v-for="country in languageList"
                                    :key="`country${country.c_idx}`"
                                    :label="country.c_lang_ko"
                                    :value="country.c_idx"
                            ></el-option>
                        </el-select>
                        <div class="input_error">{{ validation.firstError('country') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
               <td class="c_t_title">제목</td>
                <td>
                    <div>
                        <el-input v-model="title" placeholder="제목을 입력해주세요." @input="parentChange('title', title)" maxLength="50"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">내용</td>
                <td>
                    <div>
                        <el-input type="textarea" id="wr_content" v-model="content" rows="10"
                                  @input="parentChange('content', content)"></el-input>
                        <div class="input_error">{{ validation.firstError('content') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>

</template>

<script>
    import BoardValidator from "@/mixins/validators/BoardValidator"
    import summernote from "@/mixins/summernote";
    import util from "@/mixins/util";
    import languageList from "../../../mixins/languageList";
    import {mapState, mapGetters} from "vuex";
    export default {
        name: "BoardInputLayout",
        mixins: [ BoardValidator,languageList, summernote ],
        inject:['boardWriteSetData'],
        components: {},
        props: {
            boardData: {
                type: Object,
                default: () => {return {}},
            },
            setData: {
                type: Function,
                default: () => {},
            }
        },
        data() {
            return {

            }
        },
        computed: {
        },
        created() {
            this.getLanguage()
        },
        mounted() {
            this.initSummernote('wr_content' , '내용을 입력해주세요.', 'content');
            this.settingData();
        },
        methods: {
            settingData() {
                if(util.isEmpty(this.boardData)){
                    return
                }
                this.title = this.boardData.wr_subject;
                this.parentChange('title',this.title);
                this.content = this.boardData.wr_content;
                this.parentChange('content',this.content);
                this.country = this.boardData.Language[0].c_idx;
                this.parentChange('country',this.country);
                $('#wr_content').summernote('code', this.content);
            },
            parentChange(key, value) {
                this.boardWriteSetData(key, value)
            },

        },
        watch: {
            'content': {
                deep: true,
                handler: function (val, oldVal) {
                    this.parentChange('content', this.content);
                }
            },
        },
    }
</script>

<style scoped>

</style>